export default __webpack_public_path__ + "static/media/ВКО_Алтай,_Катон_Карагай,_Курчумский_районы.a0d5438a.svg";